import DeliveriesRoute from 'cio/routes/base-deliveries';

export default class DraftsRoute extends DeliveriesRoute {}
